import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Card, Col, Row, Spin, Table } from "antd";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";

class DashboardPage extends Component {
  constructor() {
    super();

    this.state = {
      statistics: {},
    };
  }

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    if (this.props.permissions.view) {
      API.dashboard
        .list()
        .then((result) => {
          this.setState({ loaded: true, statistics: result.data });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
  }

  render() {
    const { loaded, statistics } = this.state;
    const { permissions } = this.props;

    const userColumns = [
      {
        title: Resources.fullName,
        render: (val) =>
          val
            ? val.name
              ? `${val.name} ${val.family}`
              : val.family
            : "-",
      },
      {
        title: Resources.mobile,
        dataIndex: "phone",
        className: "col-center",
      },
      {
        title: Resources.count,
        dataIndex: "month_sales_count",
        className: "col-center",
      },
      {
        title: Resources.buy,
        dataIndex: "buy_price",
        className: "col-center",
        render: (val) => PriceFormat(val),
      },
      {
        title: "VIP",
        className: "col-center",
        width: "70px",
        render: (val) => (!!parseInt(val.isVip) ? Resources.vip : "-"),
      },
    ];

    const productColumns = [
      {
        title: Resources.firstName,
        dataIndex: "name",
      },
      {
        title: Resources.count,
        dataIndex: "month_sales_count",
      },
      {
        title: Resources.category,
        dataIndex: "category",
        render: (val, record) => {
          let str = "-";

          if (val) {
            str = val.name;

            if (record.sub_category) {
              str = `${str} / ${record.sub_category.name}`;
            }
          }

          return str;
        },
      },
    ];

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.dashboard}</Breadcrumb.Item>
        </Breadcrumb>
        {loaded && (
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.dailyPosition}
                  description={statistics.dailyPosition || "0"}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.sellingPrices}
                  description={PriceFormat(statistics.sellingPrices)}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.usersNow}
                  description={statistics.usersNow}
                />
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                    title={Resources.installedAppsCount}
                    description={statistics.installedApp}
                />
              </Card>
            </Col>
            <Col xs={24}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={`${Resources.maximumShop} (${Resources.month})`}
                  style={{ marginBottom: 16 }}
                />
                {!!Object.keys(statistics.maximumShop).length && (
                  <Table
                    columns={userColumns}
                    dataSource={statistics.maximumShop}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    scroll={{ x: 600 }}
                  />
                )}
              </Card>
            </Col>
            <Col xs={24}>
              <Card bordered={false}>
                <Card.Meta
                  title={`${Resources.maximumShopProduct} (${Resources.month})`}
                  style={{ marginBottom: 16 }}
                />
                <Table
                  columns={productColumns}
                  dataSource={statistics.maximumShopProduct}
                  pagination={false}
                  size="small"
                  rowKey="id"
                  scroll={{ x: 600 }}
                />
              </Card>
            </Col>
          </Row>
        )}
        {!loaded && permissions.view && <Spin className="ant-spin-center" />}
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        view: CheckPermission(state.app.user, Permissions.dashboard_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(DashboardPage);
